import { render } from "./ProductStockTransactions.vue?vue&type=template&id=c2e55436&scoped=true"
import script from "./ProductStockTransactions.vue?vue&type=script&lang=js"
export * from "./ProductStockTransactions.vue?vue&type=script&lang=js"

import "./ProductStockTransactions.vue?vue&type=style&index=0&id=c2e55436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e55436"]])

export default __exports__